
import R from 'ramda';
import * as cnt from './constants';


const initialState = {
  encryptedEmail: '',
  email: '',
  viewAs: '',
  requests: [],
  request: {},
  loadingRequest: false,
  rates: [],
  dialog: {
    files: [],
    allRequests: [],
  },
  senderId: '',
  contractId: '',
  loggedInSession: {},
  initialLoading: true,
};
const getText = (viewAs) => {
  const wrongAccountWarningText = (() => {
    if (viewAs === 'Supplier') {
      return 'At this time, Buyer accounts cannot load rates to respond to contract requests. Please either log in to a Supplier account, or sign up for a Supplier account.';
    }
    return 'At this time, TourConnect does not allow Suppliers to receive rates. Please either log in to a Buyer account, or sign up for a Buyer account.';
  })();
  return {
    ratesOrRequests: viewAs === 'Contractor' ? 'rates' : 'contract requests',
    ratesOrRequestsLabel: viewAs === 'Contractor' ? 'Rates' : 'Contract Requests',
    wrongAccountWarningText,
  };
};
export default (state = initialState, { type, payload, args }) => {
  // console.log(type, payload);
  switch (type) {
    case cnt.INIT:
    case 'VERIFY_TOKEN_SUCCESS':
      return {
        ...state,
        ...payload,
        ...payload.viewAs ? getText(payload.viewAs) : {},
      };
    case `${cnt.GET_LOGGED_IN_SESSION}_SUCCESS`:
      return {
        ...state,
        loggedInSession: {
          userId: payload.userId,
          email: payload.email,
          companyType: payload.companyType,
        },

      };
    case `${cnt.GET_ASSETS}_SUCCESS`:
      return {
        ...state,
        ...payload,
        initialLoading: false,
      };
    case cnt.OPEN_DIALOG:
      const loggedInEmail = R.path(['loggedInSession', 'email'], state);
      const loggedInType = R.path(['loggedInSession', 'companyType'], state);
      /*
      only show warning when attempting to loging AND email does not have an account or have account but wrong company type
       */
      if (loggedInEmail) {
        return {
          ...state,
          dialog: {
            showwarning: payload.type === 'login' && !(state.userId && state.companyType === state.viewAs),
            alreadyLoggedIn: true,
            sameLoggedInType: loggedInType === state.viewAs,
            ...payload,
            open: true,
          },
        };
      }
      return {
        ...state,
        dialog: {
          ...payload,
          open: true,
        },
      };
    case cnt.UPDATE_PROPS_DIALOG:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          ...payload,
        },
      };
    case `${cnt.CHANGE_CONTRACT_STATUS}_STARTED`:
    case `${cnt.CHANGE_CONTRACT_STATUS}_SUCCESS`:
      return {
        ...state,
        rates: state.rates.map(rate => {
          if(args[0].contractIds.indexOf(rate._id) > -1) {
            return {
              ...rate,
              state: args[0].state === 'received' ? 'pending' : args[0].state,
            };
          }
          return rate;
        })
      }
    case cnt.CLOSE_DIALOG:
      return {
        ...state,
        dialog: {},
      };
    case `${cnt.LOG_IN}_STARTED`:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          sending: true,
        },
      };
    case `${cnt.LOG_IN}_SUCCESS`:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          sending: false,
          success: true,
        },
      };
    case `${cnt.LOG_IN}_ERROR`:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          sending: false,
          error: true,
          loginError: (() => {
            if (payload !== 'wrongAccountType') return payload;
            return `This email is associated with a ${state.viewAs === 'Supplier' ? 'Buyer' : 'Supplier'} account. ${state.wrongAccountWarningText}`;
          })(),
        },
      };
    case `${cnt.SIGN_UP}_STARTED`:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          sending: true,
        },
      };
    case `${cnt.SIGN_UP}_SUCCESS`:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          sending: false,
          success: true,
          newUserInfo: payload,
        },
      };
    case `${cnt.SIGN_UP}_ERROR`:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          sending: false,
          error: true,
        },
      };
    case `${cnt.REQUEST_EZ_LOAD}_STARTED`:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          addingToQ: true,
        },
      };
    case `${cnt.REQUEST_EZ_LOAD}_SUCCESS`:
      return {
        ...state,
        inDLQ: true,
        requestsInDLQ: state.dialog.allRequests.filter(obj => obj.checked).map(obj => obj._id),
        dialog: {
          ...state.dialog,
          addingToQ: false,
          ezloadAddedToQ: true,
        },
      };
    case `${cnt.SEND_RATES}_STARTED`:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          sendingRates: true,
        },
      };
    case `${cnt.SEND_RATES}_SUCCESS`:
      const ratesSentRequests = state.dialog.allRequests.filter(obj => obj.checked).map(obj => obj._id);
      return {
        ...state,
        requests: state.requests.map((obj) => {
          if (ratesSentRequests.indexOf(obj._id) > -1) return { ...obj, buyerChecked: true };
          return obj;
        }),
        dialog: {
          ...state.dialog,
          sendingRates: false,
          ratesSent: true,
        },
      };
    case `[contracting-download]DOWNLOAD_SINGLE_CONTRACT_DOC_SUCCESS`:
      return {
        ...state,
        rates: state.rates.map(rate => {
          if (rate._id === payload.docId) return { ...rate, isViewed: true };
          return rate;
        }),
      };
    case `[contracting-download]BULK_DOWNLOAD_SUCCESS`:
      return {
        ...state,
        rates: state.rates.map(rate => ({ ...rate, isViewed: true })),
      };
    case '[contracting-download]ACCEPT_RATES_STARTED':
    case '[contracting-download]ACCEPT_RATES_SUCCESS':
      return {
        ...state,
        rates: state.rates.map(rate => {
          if (args[0].contractIds.indexOf(rate._id) > -1) {
            return { ...rate, state: 'accepted' };
          }
          return rate;
        }),
      };
    case '[asset-landing]GET_REQUEST':
      return {
        ...state,
        requestLoading: true,
      };
    case '[asset-landing]GET_REQUEST_SUCCESS':
      return {
        ...state,
        // in case user left after clicking the downloaded format and then came back, we want to still show the success page
        request: state.request.successfullySigned ? { ...state.request, ...payload } : payload,
        requestLoading: false,
        initialLoading: false,
      };
    case '[asset-landing]GET_REQUEST_ERROR':
      return {
        ...state,
        requestLoading: false,
      };
    case '[asset-landing]SEND_RATES_FOR_ONE_REQUEST':
      return {
        ...state,
        request: {
          ...state.request,
          sendingRates: true,
        },
      };
    case '[asset-landing]SEND_RATES_FOR_ONE_REQUEST_SUCCESS':
      return {
        ...state,
        request: {
          ...state.request,
          sendingRates: false,
          ratesSent: true,
        },
      };
    case '[asset-landing]SEND_RATES_FOR_ONE_REQUEST_ERROR':
      return {
        ...state,
        request: {
          ...state.request,
          sendingRates: false,
        },
      };
    case '[asset-landing]SIGN_RATE_DOCS':
      return {
        ...state,
        request: {
          ...state.request,
          signing: true,
        },
      };
    case '[asset-landing]SIGN_RATE_DOCS_SUCCESS':
      return {
        ...state,
        request: {
          ...state.request,
          signing: false,
          successfullySigned: true,
          createdContracts: payload.createdContracts,
        },
      };
    case '[asset-landing]SIGN_RATE_DOCS_ERROR':
      return {
        ...state,
        request: {
          ...state.request,
          signing: false,
          successfullySigned: false,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/__storeFiles__/reducer.js